import * as React from "react";
import {useCallback, useState} from "react";
import {Product} from "../types";
import {ListProductsView} from "./ListProductsView";
import {AdminProductView} from "./AdminProductView";
import {AdminStoreProductFlow} from "./AdminStoreProductFlow";
import {Inventory} from "../inventory";

interface AdminProductsFlowProps {
    products: Product[];
    inventory: Inventory;
    onLogout: () => void;
}

export function AdminProductsFlow({products, inventory, onLogout}: AdminProductsFlowProps) {
    const [selectedProduct, setSelectedProduct] = useState<Product>();
    const [storeProduct, setStoreProduct] = useState<Product>();

    const handleSelectProductCancel = useCallback(() => setSelectedProduct(undefined), []);
    const handleStoreProductDone = useCallback(() => setStoreProduct(undefined), []);

    if (storeProduct) {
        return (
            <AdminStoreProductFlow
                product={storeProduct}
                onDone={handleStoreProductDone}
            />
        );
    }

    if (selectedProduct) {
        return (
            <AdminProductView
                product={selectedProduct}
                inventory={inventory}
                onStore={setStoreProduct}
                onCancel={handleSelectProductCancel}
            />
        );
    }

    return (
        <ListProductsView
            products={products}
            inventory={inventory}
            onCancel={onLogout}
            onSelectProduct={setSelectedProduct}
        />
    );
}
